import React, { useRef } from "react";
import styled from "styled-components";

const Container = styled.input`
    border-radius : 5px;
    border : 1px solid #ccc;
    font-size: 16px;
    width: 100%;
    height: 100%;
    display: block;
    flex-grow: 1;
    padding: 10px 20px;
    box-sizing: border-box;
`

interface Props {
  placeholder?: string;
  value: React.MutableRefObject<string>; // 부모에서 ref 전달받음
  type? :string;
}

const InputBox = ({ placeholder, value, type }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null); // input 요소에 접근하기 위한 ref

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    value.current = e.target.value; // useRef 값을 직접 변경
    if (inputRef.current) {
      inputRef.current.value = e.target.value; // 실제 input 값도 변경
    }
  };

  return (
    <Container
      type={type}
      ref={inputRef} 
      placeholder={placeholder}
      defaultValue={value.current} 
      onChange={handleChange} 
    />
  );
};

export default InputBox;
